import { render } from "./PaymentReturn.vue?vue&type=template&id=f3647890&scoped=true"
import script from "./PaymentReturn.vue?vue&type=script&lang=js"
export * from "./PaymentReturn.vue?vue&type=script&lang=js"

import "./PaymentReturn.vue?vue&type=style&index=0&id=f3647890&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3647890"]])

export default __exports__